import React, { Component } from "react";
// import myImage from "../../images/white_background.JPG";
import "./Home/devresume.css";
import "./Home/print.css";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
// import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
// const pdfExportComponent = React.createRef();
class Books extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // exportPDFWithComponent = () => {
  //   if (pdfExportComponent.current) {
  //     pdfExportComponent.current.save();
  //   }
  // };
  render() {
    return (
      <div>
        <Navigations />
        <div class="main-wrapper" style={{ marginTop: "5rem" }}>
          <div class="container px-3 px-lg-5">
            <div class="d-flex justify-content-end">
              <button
                class="btn"
                style={{
                  backgroundColor: "rgb(118, 102, 223)",
                  color: "white",
                  // marginLeft: 10,
                }}
                type="button"
                onClick={() => window.print()}
              >
                Print Resume
              </button>
              {/* <button
                class="btn"
                style={{
                  backgroundColor: "rgb(118, 102, 223)",
                  color: "white",
                  // marginLeft: 10,
                }}
                type="button"
                onClick={() => this.exportPDFWithComponent()}
              >
                Download Resume
              </button> */}
              {/* <ReactToPdf targetRef={ref} filename="div-blue.pdf">
                {({ toPdf }) => <button onClick={toPdf}>Generate pdf</button>}
              </ReactToPdf> */}
            </div>
            <article class="resume-wrapper mx-auto theme-bg-light p-5 mb-5 my-5 shadow-lg">
              {/* <PDFExport
                ref={pdfExportComponent}
                paperSize="auto"
                margin={40}
                fileName={`Report for ${new Date().getFullYear()}`}
                author="KendoReact Team"
              > */}
              <page id="divToPrint" size="A4" class="section-to-print">
                <div class="resume-header">
                  <div class="row align-items-center">
                    <div class="resume-title col-12 col-md-6 col-lg-8 col-xl-9">
                      <h2 class="resume-name mb-0 text-uppercase changeFont">
                        Adnan Ahmed
                      </h2>
                      <div class="resume-tagline mb-3 mb-md-0 changeFont">
                        Front End Developer | React & React Native
                      </div>
                    </div>
                    {/* <!--//resume-title--> */}
                    <div class="resume-contact col-12 col-md-6 col-lg-4 col-xl-3">
                      <ul class="list-unstyled mb-0">
                        <li class="mb-2">
                          <i class="fas fa-phone-square fa-fw fa-lg me-2 "></i>
                          <a
                            class="resume-link changeFont"
                            href="tel:+92 345 304 8496"
                            style={{ fontSize: "15.5px" }}
                          >
                            +92 345 304 8496
                          </a>
                        </li>
                        <li class="mb-2">
                          <i class="fas fa-envelope-square fa-fw fa-lg me-2"></i>
                          <a
                            class="resume-link changeFont"
                            href="mailto:adnanahmed818@gmail.com"
                            style={{ fontSize: "15.5px" }}
                          >
                            adnanahmed818@gmail.com
                          </a>
                        </li>
                        <li class="mb-2">
                          <i class="fas fa-globe fa-fw fa-lg me-2"></i>
                          <a
                            class="resume-link changeFont"
                            href="https://eight-1-eight.web.app"
                            target="_blank"
                            style={{ fontSize: "15.5px" }}
                          >
                            eight-1-eight.web.app
                          </a>
                        </li>
                        <li class="mb-0 changeFont">
                          <i class="fas fa-map-marker-alt fa-fw fa-lg me-2"></i>
                          <a
                            class="resume-link changeFont"
                            // href="https://eight-1-eight.web.app"
                            target="_blank"
                            style={{ fontSize: "15.5px" }}
                          >
                            Karachi, Pakistan
                          </a>
                        </li>
                      </ul>
                    </div>
                    {/* <!--//resume-contact--> */}
                  </div>
                  {/* <!--//row--> */}
                </div>
                {/* <!--//resume-header--> */}
                <hr />
                <div class="resume-intro">
                  <div class="row align-items-center">
                    {/* <div class="col-12 col-md-3 col-xl-2 text-center">
                    <img
                      class="resume-profile-image mb-3 mb-md-0 me-md-5  ms-md-0 rounded mx-auto"
                      src={myImage}
                      alt="image"
                    />
                  </div> */}

                    <div class="col text-start">
                      <p
                        class="mb-0 changeFont text-justify"
                        style={{ fontSize: "16.5px" }}
                      >
                        Experience Front End Developer interested in building
                        usable, useful, well-constructed websites &
                        applications. Interested in continuation of learning and
                        cooperation with excellent people. <br />
                        Currently working on modern platforms and technologies
                        like React Native Material Design (Materialize CSS,
                        Material UI React), JavaScript, ReactJs, Redux,
                        Firebase, Bootstrap, HTML, HTML5, CSS, CSS3, Github, &
                        Third-Party API Integrations, etc. Have strong knowledge
                        in developing single-page applications (SPA) with pixel
                        perfect UI/UX design.
                      </p>
                    </div>
                    {/* <!--//col--> */}
                  </div>
                </div>
                {/* <!--//resume-intro--> */}
                <hr />
                <div class="resume-body">
                  <div class="row">
                    <div class="resume-main col-12 col-lg-8 col-xl-9   pe-0   pe-lg-5">
                      <section class="work-section py-3">
                        <h3 class="text-uppercase resume-section-heading mb-4 ">
                          Work Experiences
                        </h3>
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <span
                              style={{ fontSize: "1rem" }}
                              class="item-title col-12 col-md-6 col-lg-8 mb-md-0 changeFont"
                            >
                              Data Entry Operator <br />
                              <span
                                style={{ fontSize: "14px" }}
                                class="text-muted "
                              >
                                {" "}
                                Liaquat National Hospital & Medical College
                              </span>
                            </span>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              2014 - Present
                            </div>
                          </div>
                          <div class="item-content">
                            {/* <p class="text-justify changeFont">
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Donec quam felis, ultricies nec,
                            pellentesque eu, pretium quis, sem. Donec pede
                            justo, fringilla vel. Lorem ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Donec quam felis.
                          </p> */}
                            <ul class="resume-list ">
                              <li class="changeFont">
                                Transcription of Clinical Biochemistry Lab
                                reports, Extensive use of software (H.I.M.S) for
                                pathology transcription and record keeping.
                                Proficient keyboarding and spelling skills.
                                Knowledge of medical terminology.
                              </li>
                              <li class="changeFont">
                                Installing new systems for all paramedic’s staff
                                (H.I.S). Providing training for all users.
                              </li>
                              <li class="changeFont">
                                Explaining complex IT issues to non-technical
                                employees.
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* <!--//item--> */}
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <span
                              style={{ fontSize: "1rem" }}
                              class="item-title col-12 col-md-6 col-lg-8 mb-md-0 changeFont"
                            >
                              Medical Transcriptionist <br />
                              <span
                                style={{ fontSize: "14px" }}
                                class="text-muted "
                              >
                                {" "}
                                Zainab Panjwani Memorial Hospital
                              </span>
                            </span>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              2012 - 2014
                            </div>
                          </div>
                          <div class="item-content">
                            {/* <p>
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Donec quam felis, ultricies nec,
                            pellentesque eu, pretium quis, sem. Donec pede
                            justo, fringilla vel.
                          </p> */}
                            <ul class="resume-list ">
                              <li class="changeFont">
                                Typed test reports and other details of patients
                                and saved them in digital format. (Laboratory,
                                X-Ray, Ultrasound and Histopathology).
                              </li>
                              <li class="changeFont">
                                Reviewed medical records to ensure correct
                                spelling, terminology, and grammar.
                              </li>
                              <li class="changeFont">
                                Hospital Management Information System (HMIS) an
                                asp.net base operating system.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <span
                              style={{ fontSize: "1rem" }}
                              class="item-title col-12 col-md-6 col-lg-8 mb-md-0 changeFont"
                            >
                              Senior Computer Operator <br />
                              <span
                                style={{ fontSize: "14px" }}
                                class="text-muted "
                              >
                                IGLOO ice cream - Pakistan Dairy Products (Pvt)
                                Ltd.
                              </span>
                            </span>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              2011 - 2012
                            </div>
                          </div>
                          <div class="item-content">
                            {/* <p>
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Donec quam felis, ultricies nec,
                            pellentesque eu, pretium quis, sem. Donec pede
                            justo, fringilla vel.
                          </p> */}
                            <ul class="resume-list ">
                              <li class="changeFont">
                                Processing purchase orders, invoices
                              </li>
                              <li class="changeFont">
                                Typing documents, invoices and bills.
                              </li>
                              <li class="changeFont">
                                Responsible for company orders onto the records
                                system.
                              </li>
                              <li class="changeFont">
                                Data processing and updating customer files
                                daily.
                              </li>
                              <li class="changeFont">
                                Inputting large amount of data in to computer
                                databases.
                              </li>
                              <li class="changeFont">
                                Transfer information that is on paper to
                                computer files.
                              </li>
                              <li class="changeFont">
                                Microsoft Visual Fox Pro system.
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* <!--//item--> */}
                        {/* <div class="item">
                        <div class="item-heading row align-items-center mb-2">
                          <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
                            Senior Developer
                          </h4>
                          <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                            Uber | 2013 - 2014
                          </div>
                        </div>
                        <div class="item-content">
                          <p>
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus.{" "}
                          </p>
                        </div>
                      </div> */}
                        {/* <!--//item--> */}
                        {/* <div class="item">
                        <div class="item-heading row align-items-center mb-2">
                          <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
                            Backend Developer
                          </h4>
                          <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                            Amazon | 2014 - 2016
                          </div>
                        </div>
                        <div class="item-content">
                          <p>
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus.
                          </p>
                        </div>
                      </div> */}
                        {/* <!--//item--> */}
                        {/* <div class="item">
                        <div class="item-heading row align-items-center mb-2">
                          <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
                            Frontend Developer
                          </h4>
                          <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                            Startup | 2013 - 2014
                          </div>
                        </div>
                        <div class="item-content">
                          <p>
                            Role description goes here ipsum dolor sit amet,
                            consectetuer adipiscing elit. Aenean commodo ligula
                            eget dolor. Aenean massa. Cum sociis natoque
                            penatibus.{" "}
                          </p>
                        </div>
                      </div> */}
                        {/* <!--//item--> */}
                      </section>
                      {/* <!--//work-section--> */}

                      <section class="project-section py-3">
                        <h3 class="text-uppercase resume-section-heading mb-4 ">
                          Projects
                        </h3>
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0 ">
                              Belk Academy
                            </h4>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              www.belk-academy.com/
                            </div>
                          </div>
                          <div class="item-content ">
                            <p class="text-justify changeFont">
                              Whether you are a trainer or a training
                              organization, BELK Academy is made for you. <br />{" "}
                              When you are a trainer and want to look for one or
                              more missions, just contact us on the platform.
                              Once your profile is validated by our team, it
                              will be anonymized and published on the site.
                            </p>
                          </div>
                        </div>
                        {/* <!--//item--> */}
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0 ">
                              Sayyid & Shaykh
                            </h4>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              sayyidandshaykh.com/
                            </div>
                          </div>
                          <div class="item-content ">
                            <p class="text-justify changeFont">
                              Sayyid and Shaykh is a global law firm offers a
                              broad spectrum of legal services including
                              litigation, arbitration, Company Secretarial
                              services, taxation, Property and Real Estate,
                              Intellectual Property, ADR and general legal
                              consultancy. The firm ensures cost effective
                              representation and personalized attention of its
                              Partners to maintain the quality of work and to
                              deliver practical and innovative solutions to the
                              clients.
                            </p>
                          </div>
                        </div>
                        {/* <!--//item--> */}
                        <div class="item mb-3">
                          <div class="item-heading row align-items-center mb-2">
                            <h4 class="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0 ">
                              Kafe UPNM
                            </h4>
                            <div class="item-meta col-12 col-md-6 col-lg-4 text-muted text-start text-md-end">
                              kafeupnm.web.app/
                            </div>
                          </div>
                          <div class="item-content ">
                            <p class="text-justify changeFont">
                              kafeupnm is a Food Delivery App like Uber Eats,
                              Food Panda.
                            </p>
                          </div>
                        </div>
                        {/* <!--//item--> */}
                      </section>
                      {/* <!--//project-section--> */}
                    </div>
                    {/* <!--//resume-main--> */}
                    <aside class="resume-aside col-12 col-lg-4 col-xl-3 px-lg-4 pb-lg-4">
                      <section class="skills-section py-3">
                        <h3 class="text-uppercase resume-section-heading mb-4">
                          Skills
                        </h3>
                        <div class="item">
                          <h4 class="item-title">Technical</h4>
                          <ul class="list-unstyled resume-skills-list">
                            <li class="mb-2 changeFont">
                              JavaScript / React / React Native
                            </li>
                            <li class="mb-2 changeFont">HTML / CSS</li>
                            <li class="mb-2 changeFont">
                              Bootstrap / Material UI / Tailwind CSS
                            </li>
                            <li class="mb-2 changeFont">Firebase / MongoDB</li>
                            <li class="mb-2 changeFont">
                              Object-oriented design
                            </li>
                            <li class="mb-2 changeFont">
                              Design and implement database structures
                            </li>
                            {/* <li>Lead and deliver complex software systems</li> */}
                          </ul>
                        </div>

                        <div class="item">
                          <h4 class="item-title">Professional</h4>
                          <ul class="list-unstyled resume-skills-list">
                            <li class="mb-2 changeFont">
                              Effective communication
                            </li>
                            <li class="mb-2 changeFont">Team player</li>
                            <li class="mb-2 changeFont">
                              Strong problem solver
                            </li>
                            <li class="changeFont">Good time management</li>
                          </ul>
                        </div>
                      </section>

                      <section class="education-section py-3">
                        <h3 class="text-uppercase resume-section-heading mb-4">
                          Education
                        </h3>
                        <ul class="list-unstyled resume-education-list">
                          <li class="mb-3">
                            <div class="resume-degree ">
                              Web & Mobile App Developer
                            </div>
                            <div class="resume-degree-org text-muted">
                              S.M.I.T | Saylani Head Office, Bahadurabad
                            </div>
                            <div class="resume-degree-time text-muted">
                              2017 - 2019
                            </div>
                          </li>
                          <li>
                            <div class="resume-degree ">Intermediate</div>
                            <div class="resume-degree-org text-muted">
                              Govt. Jinnah College | Matric Board Office
                            </div>
                            <div class="resume-degree-time text-muted">
                              2007 - 2009
                            </div>
                          </li>
                        </ul>
                      </section>
                      {/* <!--//education-section--> */}
                      <section class="education-section py-3">
                        <h3 class="text-uppercase resume-section-heading mb-4">
                          Recent Work
                        </h3>
                        <ul class="list-unstyled resume-awards-list">
                          <li class="mb-3">
                            <div class="">SavPersonal App</div>
                            <div class="text-muted">React Native | Expo</div>
                          </li>
                          <li class="mb-3">
                            <div class="">COV-E-DASH App (COVID-19)</div>
                            <div class="text-muted">React Native | Expo</div>
                          </li>
                          <li class="mb-3">
                            <div class="">
                              P.O.S Web App (Medicine Wholesale)
                            </div>
                            <div class="text-muted">React | Firebase</div>
                          </li>
                          <li class="mb-3">
                            <div class="">News App</div>
                            <div class="text-muted">React Native | Expo</div>
                          </li>
                          <li class="mb-3">
                            <div class="">
                              Awsome Foodies Web & Mobile (Food Delivery)
                            </div>
                            <div class="text-muted">
                              React, React Native | Expo
                            </div>
                          </li>
                        </ul>
                      </section>
                      {/* <!--//education-section--> */}
                      {/* <section class="skills-section py-3">
                      <h3 class="text-uppercase resume-section-heading mb-4">
                        Languages
                      </h3>
                      <ul class="list-unstyled resume-lang-list">
                        <li class="mb-2">
                          English <span class="text-muted">(Native)</span>
                        </li>
                        <li>
                          Spanish <span class="text-muted">(Professional)</span>
                        </li>
                      // </ul>
                    </section> */}
                      {/* <!--//certificates-section--> */}
                      {/* <section class="skills-section py-3">
                      <h3 class="text-uppercase resume-section-heading mb-4">
                        Interests
                      </h3>
                      <ul class="list-unstyled resume-interests-list mb-0">
                        <li class="mb-2">Climbing</li>
                        <li class="mb-2">Snowboarding</li>
                        <li class="mb-2">Photography</li>
                        <li>Travelling</li>
                      </ul>
                    </section> */}
                      {/* <!--//certificates-section--> */}
                    </aside>
                    {/* <!--//resume-aside--> */}
                  </div>
                  {/* <!--//row--> */}
                </div>
                {/* <!--//resume-body--> */}
                <hr />
                <div class="resume-footer text-center">
                  <ul class="resume-social-list list-inline mx-auto mb-0 d-inline-block text-muted">
                    <li class="list-inline-item mb-lg-0 me-3">
                      <a
                        class="resume-link"
                        href="https://github.com/fidato818"
                        target="_blank"
                      >
                        <i
                          class="fab fa-github-square fa-2x me-2"
                          data-fa-transform="down-4"
                          style={{ color: "#7666df" }}
                        ></i>
                        <span class=" d-lg-inline-block text-muted">
                          github.com/fidato818
                        </span>
                      </a>
                    </li>
                    <li class="list-inline-item mb-lg-0 me-3">
                      <a
                        class="resume-link"
                        href="https://linkedin.com/in/adnan-ahmed818"
                        target="_blank"
                      >
                        <i
                          class="fab fa-linkedin fa-2x me-2"
                          data-fa-transform="down-4"
                          style={{ color: "#7666df" }}
                        ></i>
                        <span class=" d-lg-inline-block text-muted">
                          linkedin.com/in/adnan-ahmed818
                        </span>
                      </a>
                    </li>
                    <li class="list-inline-item mb-lg-0 me-lg-3">
                      <a
                        class="resume-link"
                        href="https://twitter.com/AdnanAhmed_818"
                        target="_blank"
                      >
                        <i
                          class="fab fa-twitter-square fa-2x me-2"
                          data-fa-transform="down-4"
                          style={{ color: "#7666df" }}
                        ></i>
                        <span class=" d-lg-inline-block text-muted">
                          @AdnanAhmed_818
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <!--//resume-footer--> */}
              </page>{" "}
              {/* </PDFExport> */}
            </article>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Books;
